import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {LovValue} from '../../../api/model/LovValue.model';
import {LovValueConverter} from '../../../api/converter/LovValue.converter';
import {LovValueDataService} from './lovValueData.service';


@Injectable({providedIn: 'root'})
export class LovValueDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<LovValue, LovValueConverter> {
    constructor(dataService: LovValueDataService, converter: LovValueConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): LovValue {
        return new LovValue();
    }
}
